import styled from "@emotion/styled";

export const DisplayComponent = styled.div<{ show: boolean }>`
    position: relative;
    display: ${({ show }) => (show ? "block" : "none")};
`;
